document.addEventListener('alpine:init', () => {
  Alpine.data('discount', (initData) => ({
    discount: '',
    show: false,
    error: false,
    async applyDiscount () {
      this.error = false;
      const response = await fetch(`/api/checkouts/${initData.id}/discount`, {
        method: 'POST',
        body: JSON.stringify({
          discount: this.discount
        })
      })
      const data = await response.json()
      if (!data.discount_code) {
        this.error = true;
      }
      else {
        if (initData.reloadOnSuccess) {
          window.location.reload()
        }
        this.activeDiscount = data.discount_code;
        this.total = data.quote.price_incl;
        let subtotal = 0
        for (let index = 0; index < data.products.length; index++) {
          const element = data.products[index];
          subtotal += element.base_price_incl * element.quantity
        }
        this.subtotal = subtotal;
        this.shipping = data.shipment_method ? data.shipment_method.price_incl : 0
        this.show = false
        this.$dispatch('update-cart')
      }
    },
    async removeDiscount () {
      const response = await fetch(`/api/checkouts/${initData.id}/discount`, {
        method: 'POST',
        body: JSON.stringify({
          discount: null
        })
      })
      const data = await response.json()
      this.activeDiscount = data.discount_code;
      this.total = data.quote.price_incl;
      this.subtotal = data.quote.price_incl;
      this.shipping = data.shipment_method ? data.shipment_method.price_incl : 0
      this.$dispatch('update-cart')
      if (initData.reloadOnSuccess) {
        window.location.reload()
      }
    }
  }))
})